var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7061 0.173828C23.5608 0.173828 0.589233 23.1454 0.589233 51.2907C0.589233 79.436 23.5608 102.408 51.7061 102.408C79.8514 102.408 102.823 79.436 102.823 51.2907C102.823 23.1454 79.8514 0.173828 51.7061 0.173828ZM14.8688 51.2907C14.8688 40.7362 19.4218 31.0095 26.665 24.3871C29.5623 21.6967 34.5292 22.5245 36.5987 26.0427L49.4296 48.1865C50.6713 50.256 50.6713 52.7393 49.4296 54.8088L36.5987 76.9526C34.5292 80.6777 29.5624 81.2985 26.4581 78.4012C19.4218 71.3649 14.8688 61.8452 14.8688 51.2907ZM66.8135 76.5387L53.9826 54.395C52.7408 52.3255 52.7408 49.842 53.9826 47.7725L66.8135 25.6288C68.883 22.1106 73.6429 21.2828 76.7471 23.9732C83.9904 30.5956 88.5434 40.3223 88.5434 50.8768C88.5434 61.4313 83.9904 71.158 76.7471 77.7804C73.6429 81.0916 68.883 80.2638 66.8135 76.5387Z",
    fill: "#2029DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo6.1155272f82090625345e92dd8422579a.svg";
export { ForwardRef as ReactComponent };